import { twoDigits } from './numbers';

export const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'GBP',
});

/**
 * Formats decimal hours into hours and minutes.
 *
 * @param {number} decimalHours - The decimal hours to format.
 * @return {string} The formatted hours and minutes string.
 */
export const decimalHoursFormatter = (decimalHours: number) => {
  const [hours = 0, mins = 0] = decimalHours.toString().split('.');
  return `${twoDigits(hours)} hrs ${twoDigits(mins)} mins`;
};

/**
 * Renders a rate the backend sends as a decimal string ("0.2000") as a percentage ("20%").
 * VAT rates come down per line so the screen never has to assume the current 20% is the rate
 * a given pay run was actually charged at. Null for a worker charged at more than one rate.
 */
export const formatPercent = (rate?: string | number | null) => {
  if (rate === null || rate === undefined || rate === '') return '';
  const value = Number(rate);
  if (Number.isNaN(value)) return '';
  // Trim the trailing zeros a stored "0.2000" would otherwise show as "20.00%".
  return `${Number((value * 100).toFixed(2))}%`;
};
